// extracted by mini-css-extract-plugin
export var quantityInput = "_ik-0";